import React from 'react';
import { useEffect, useState } from 'react';
import { Form, FormGroup, Input, Label, Table } from 'reactstrap';



//Odds function 
export function Betika() {
    const [data, setData] = useState([])
    useEffect(() => {
        fetch('http://localhost:8081/table/betika_table')
            .then(res => res.json())
            .then(data => setData(data))
            .catch(err => console.log(err));
    }, [])
    //function to calculate true odds
    const percentage_1 = (Home_Odds) => {
        return (100 / Home_Odds).toFixed(2);
    }
    //finding the percentage of x
    const percentage_X = (Draw_Odds) => {
        return (100 / Draw_Odds).toFixed(2);
    }
    //findig the percentage of 2
    const percentage_2 = (Away_Odds) => {
        return (100 / Away_Odds).toFixed(2);
    }
    //total percentage

    const totalPercentage = (Home_Odds, Draw_Odds, Away_Odds) => {
        const percent_1 = percentage_1(Home_Odds);
        const percent_X = percentage_X(Draw_Odds);
        const percent_2 = percentage_2(Away_Odds);
        return (parseFloat(percent_1) + parseFloat(percent_X) + parseFloat(percent_2)).toFixed(2);
    }
    //removing the juice
    //home
    const calculatedOdds1 = (totalPercentage, percentage_1) => {
        const odds1 = totalPercentage / percentage_1;
        return parseFloat(odds1.toFixed(2));
    }
    //draw
    const calculatedOddsx = (totalPercentage, percentage_X) => {
        const oddsX = totalPercentage / percentage_X;
        return parseFloat(oddsX.toFixed(2));
    }
    //Away

    const calculatedOdds2 = (totalPercentage, percentage_2) => {
        const odds2 = totalPercentage / percentage_2;
        return parseFloat(odds2.toFixed(2));
    }

    //gap1
    const calculatedGap1 = (calculatedOdds1, Home_Odds) => {
        const gap1 = calculatedOdds1 - Home_Odds;
        return parseFloat(gap1.toFixed(2));
    }
    // gap x
    const calculatedGapx = (calculatedOddsx, Draw_Odds) => {
        const gapx = calculatedOddsx - Draw_Odds;
        return parseFloat(gapx.toFixed(2));
    }
    //gap 2
    const calculatedGap2 = (calculatedOdds2, Away_Odds) => {
        const gap2 = calculatedOdds2 - Away_Odds;
        return parseFloat(gap2.toFixed(2));
    }

    return (
        <>
            <div className='alg1_card'>
                <Table striped>
                    <thead>
                        <tr>
                            <th> Team_A</th>
                            <th> Team_B </th>
                            <th>League</th>
                            <th>Time </th>
                            <th>1_Odds</th>
                            <th>X_Odds</th>
                            <th>2_Odds</th>
                            <th>1</th>
                            <th>X</th>
                            <th>2</th>
                            <th>Gap1</th>
                            <th>GapX</th>
                            <th>Gap2</th>
                            <th>Over2.5</th>
                        </tr>
                    </thead>

                    <tbody>

                        {data.map((d, i) => (
                            <tr key={i}>
                                <th scope="row">{d.Home_Team}</th>
                                <td>{d.Away_Team}</td>
                                <td>{d.League} </td>
                                <td>{d.Time}</td>
                                <td>{d.Home_Odds}</td>
                                <td>{d.Draw_Odds}</td>
                                <td>{d.Away_Odds}  </td>
                                <td>{calculatedOdds1(totalPercentage(d.Home_Odds, d.Draw_Odds, d.Away_Odds), percentage_1(d.Home_Odds))}</td>
                                <td> {calculatedOddsx(totalPercentage(d.Home_Odds, d.Draw_Odds, d.Away_Odds), percentage_X(d.Draw_Odds))} </td>
                                <td>{calculatedOdds2(totalPercentage(d.Home_Odds, d.Draw_Odds, d.Away_Odds), percentage_2(d.Away_Odds))} </td>
                                <td>{calculatedGap1(calculatedOdds1(totalPercentage(d.Home_Odds, d.Draw_Odds, d.Away_Odds), percentage_1(d.Home_Odds)), d.Home_Odds)} </td>
                                <td>{calculatedGapx(calculatedOddsx(totalPercentage(d.Home_Odds, d.Draw_Odds, d.Away_Odds), percentage_1(d.Draw_Odds)), d.Draw_Odds)} </td>
                                <td>{calculatedGap2(calculatedOddsx(totalPercentage(d.Home_Odds, d.Draw_Odds, d.Away_Odds), percentage_1(d.Away_Odds)), d.Away_Odds)} </td>


                            </tr>
                        ))}


                    </tbody>
                </Table>
            </div>

        </>
    );
}

